/**
* @ngdoc service
* @name catalog.product.service:ProductCustomizeService
* @description
* Servicio para manejar la personalización de un producto
*/
(function() {
    'use strict';

    angular
    .module('itxApp.catalog')
    .service('ProductCustomizeService', ProductCustomizeService);

    ProductCustomizeService.$inject = [
        '$q',
        'CmsConfigSvc',
        'ngDialog',
        '$http',
        'ItxUtilsFct',
        'ItxConstants'
    ];

    function ProductCustomizeService (
        $q,
        CmsConfigSvc,
        ngDialog,
        $http,
        ItxUtilsFct,
        ItxConstants
    ) {

        var _this = this;   
        _this.blacklist = {
            url: window.staticContent + '/configurations/blacklist.json?t=' + inditex.iRegistryTs,
            cached: true,
            list: []
        };
        
        var service =  {
            getProductImages: getProductImages,
            getProductCustomizations: getProductCustomizations,
            openCustomizeProduct: openCustomizeProduct,
            getBlacklist: getBlacklist
        };

        return service;

        function openCustomizeProduct(product) {
            // Obtenemos las opciones de personalización del producto dado y en caso de resolverse abirmos la modal
            service.getProductCustomizations(product)
            .then(function(configuration) {

                var productCustomizationDialog = {
                    template: '<itx-product-customize product="ngDialogData.product" product-customizations="ngDialogData.productCustomizations"></itx-product-customize>',
                    className: 'ngdialog-theme-plain ngdialog new-modal ma-modal-lg md-customize  size-detail-layout ',
                    showClose: true,
                    plain: true,
                    data: {
                        product: product, // Pasamos el producto
                        productCustomizations: configuration // Pasamos las opciones de personalización del producto
                    }
                };

                ngDialog.open(productCustomizationDialog);                  
            })
            .catch(function(error){
                console.error(error);
            });    
        }

        // Obtiene las opciones de personalización de un producto dado
        function getProductCustomizations(product) {

            var deferred = $q.defer();

            _this.options = {
                areas: []
            };

            // Obtenemos las imágenes de tipo personalizado del producto dado
            var productImages = service.getProductImages(product);     
                        
            // Realizamos las consultas solo en caso de que el producto tenga imágenes del tipo personalizadp
            if(productImages.length > 0)
            {
                var productAreaImages = _.keyBy(productImages, 'area');

                // Obtenemos las opciones de personalización genéricas del CMS
                CmsConfigSvc.getProperty('product_customization_info')
                    .then(function(productCustomizations){
                        
                        // Añadimos información de las areas disponibles en base a los atributos del producto
                        _.forEach(product.attributes, function(attribute) {    
                            if(attribute.type === 'XCUSTOMIZATIONS'){
                                _.forEach(productCustomizations.areas, function(area) {                                
                                    if(attribute.name === area.attribute) {
                                        if(_.has(productAreaImages, area.type)){
                                            //area.name = attribute.name;
                                            area.image = productAreaImages[area.type];
                                            _this.options.areas.push(area);
                                        }
                                    }    
                                });
                            }            
                        });

                        if(_this.options.areas.length>0){
                             // Añadimos las tipografías, colores y tipo de estampado en base al tipo de estampado de las areas
                            _this.options.type = _this.options.areas[0].customizationType;
                            _this.options.typographies = productCustomizations[_this.options.type].typographies;
                            _this.options.colors = productCustomizations[_this.options.type].colors;
                            deferred.resolve(_this.options);
                        } else {
                            deferred.reject('Las areas de este producto no coinciden con los atributos que vienen en el mismo');
                        }
                    })
                    .catch(function(error){
                        return deferred.reject(error);
                    });

                return deferred.promise;
            }
            // En caso contrario, devolvemos error para imposibilitar que se abra la ventana modal
            else {

                deferred.reject('Este producto no tiene imágenes validas');

                return deferred.promise;
            }
            
        }


        // Obtiene las imágenes de personalización de un producto dado
        function getProductImages(product) {
            
            var mainImage = product.getImageNoXmedia();
            
            // Recortamos la URL base
            // var baseUrl = mainImage.split('/');
            // baseUrl = baseUrl.slice(0, -3).join('/');
            var ref = product.detail.displayReference;
            var baseUrl = mainImage.slice(0, mainImage.indexOf(ref) ) + ref;

            var color = product.mainColorid;
            if(product.state.selectedColor){
                color = product.state.selectedColor.id;
            }

            // Recorremos las imágenes del producto para coger solo las que nos interesan
            var images = [];
            if(product.activeDetail.xmedia){
                var productMedias = product.activeDetail.xmedia[0].xmediaItems[0].medias;
                _.forEach(product.activeDetail.xmedia, function(media) {
                    if(media.colorCode == color){
                        productMedias = media.xmediaItems[0].medias;
                    }
                });                

                _.forEach(productMedias,function(media) {
                    
                    // Miraremos solo las imágenes que tengan la clase 12 y que contengan "extra info"
                    if(media.clazz === 12 && !_.isEmpty(media.extraInfo)) {
                        
                        // Añadimos la imagen en el array de imágenes que usaremos para las personalizaciones
                        images.push({
                            url: baseUrl + '/' + color + '/' + media.idMedia + '16.jpg?ts=' + media.timestamp,
                            customizableInfo: media.extraInfo.customizableInfo,
                            area: media.extraInfo.custom_type
                        })
                    }
    
                });
            }
            return images;
        }

        function getBlacklist() {
            var deferred = $q.defer();
            if(_this.blacklist.cached){
                $http.get(_this.blacklist.url)
                .then(function (res) {
                    _this.blacklist.cached = true;
                    _this.blacklist.list = _.keyBy(res.data, function (res){
                        return res.value.toUpperCase();
                    });
                    deferred.resolve(_this.blacklist.list);
                })
                .catch(function (error) {
                    console.error('PRODUCT CUSTOMIZE - Get openshift blacklist error');
                    deferred.reject(error);
                });
            } else {
                deferred.resolve(_this.blacklist.list);
            }
            return deferred.promise;
        }

    }

})();